import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { AdministrationStores } from '../stores';
import { Layout, Table, Button, Tooltip } from 'antd';
import EditProjectUsers from './EditProjectUsers/EditProjectUsers';

const { Content } = Layout;

type Props = AdministrationStores;

interface ProjectUserCount {
    projectId: string;
    projectName: string;
    assignedUsersCount: number;
}

const UsersProjectViewComponent: React.FC<Props> = ({ ProjectAssignment: store, UsersManager: usersManagerStore }) => {
    const [editModalVisible, setEditModalVisible] = React.useState(false);
    const [selectedProject, setSelectedProject] = React.useState<{ id: string; name: string } | null>(null);

    const handleEditProject = (project: ProjectUserCount) => {
        setSelectedProject({ id: project.projectId, name: project.projectName });
        setEditModalVisible(true);
    };

    const handleCloseModal = () => {
        setEditModalVisible(false);
        setSelectedProject(null);
    };

    if (!store) {
        return null;
    }

    const columns = [
        {
            title: 'Project Name',
            dataIndex: 'projectName',
            key: 'projectName',
            sorter: (a: ProjectUserCount, b: ProjectUserCount) => a.projectName.localeCompare(b.projectName)
        },
        {
            title: 'Project ID',
            key: 'projectId',
            render: (project: ProjectUserCount) => (
                <span data-id-name="ProjectId" style={{ color: '#8c8c8c' }}>
                    {project.projectId}
                </span>
            )
        },
        {
            title: 'Number of Users',
            dataIndex: 'assignedUsersCount',
            key: 'assignedUsersCount',
            sorter: (a: ProjectUserCount, b: ProjectUserCount) => a.assignedUsersCount - b.assignedUsersCount,
            align: 'right' as const
        },
        {
            title: '',
            key: 'actions',
            width: 80,
            align: 'center' as const,
            render: (record: ProjectUserCount) => (
                <div className="row-actions-wrapper">
                    <Tooltip title="Edit Project Users">
                        <Button type="link" size="small" onClick={() => handleEditProject(record)}>
                            <i className="alpha-icon lg edit-icon" />
                        </Button>
                    </Tooltip>
                </div>
            )
        }
    ];

    return (
        <Layout className="screen-size" style={{ height: '100%', background: 'white' }}>
            <Content>
                <Table
                    className="alpha-portal-table"
                    columns={columns}
                    dataSource={store?.projectUserCounts || []}
                    rowKey="projectId"
                    scroll={{ y: 'calc(100vh - 154px)' }}
                    pagination={false}
                />
                {store?.projectUserCounts?.length === 0 && <div>No projects found.</div>}

                {selectedProject && (
                    <EditProjectUsers
                        visible={editModalVisible}
                        onClose={handleCloseModal}
                        projectId={selectedProject.id}
                        projectName={selectedProject.name}
                        store={store}
                        usersManagerStore={usersManagerStore}
                    />
                )}
            </Content>
        </Layout>
    );
};

export const UsersProjectView = observer(UsersProjectViewComponent);

export default UsersProjectView;
